import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  DetachedRouteHandle,
  RouteReuseStrategy,
} from '@angular/router';

// EXT-6013: detaches (rather than destroys) a route's component tree when
// navigating away, so its component instances -- and everything they hold in
// FormGroups/signals -- survive until the user navigates back. Opt-in via
// `data: { reuseComponent: true }` on a route, so every other route keeps
// Angular's default behavior untouched.
@Injectable()
export class ReuseComponentRouteStrategy implements RouteReuseStrategy {
  private readonly storedRoutes = new Map<string, DetachedRouteHandle>();

  private getKey(route: ActivatedRouteSnapshot): string | null {
    return route.routeConfig?.data?.['reuseComponent']
      ? (route.routeConfig.path ?? null)
      : null;
  }

  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return this.getKey(route) !== null;
  }

  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle | null): void {
    const key = this.getKey(route);
    if (key && handle) this.storedRoutes.set(key, handle);
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    const key = this.getKey(route);
    return !!key && this.storedRoutes.has(key);
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    const key = this.getKey(route);
    return key ? (this.storedRoutes.get(key) ?? null) : null;
  }

  shouldReuseRoute(
    future: ActivatedRouteSnapshot,
    curr: ActivatedRouteSnapshot,
  ): boolean {
    return future.routeConfig === curr.routeConfig;
  }
}
